import React, { CSSProperties, ReactElement } from 'react';

import { TooltipProps as MuiTooltipProps } from '@mui/material/Tooltip';

import { BlackStyledTooltip } from './BlackTooltip.styles';

export interface BlackTooltipProps extends Omit<MuiTooltipProps, 'sx'> {
    title: ReactElement | string;
    children: ReactElement;
    style?: CSSProperties;
}

export const BlackTooltip = ({ children, style, ...props }: BlackTooltipProps) => {
    return (
        <BlackStyledTooltip {...props}>
            <div style={style}>{children}</div>
        </BlackStyledTooltip>
    );
};
